import React, { useState } from 'react'
import { apiPut } from '../../utils/apiFetch'
import apiPath from '../../utils/pathObj'
import { useForm } from 'react-hook-form'
import useToastContext from 'hooks/useToastContext'
import OInputField from 'components/reusable/OInputField'
import { useTranslation } from 'react-i18next'
import { validationRules } from '../../utils/constants'
import { preventMax } from '../../utils/validations'
import helpers from 'utils/helpers'

const EditStaff = ({ setEditShowModal, getAllStaffs, item }) => {
  const { t } = useTranslation()
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors }
  } = useForm({
    mode: 'onChange',
    shouldFocusError: true,
    defaultValues: {
      first_name: item?.first_name,
      last_name: item?.last_name,
      email: item?.email,
      country_code: item?.country_code,
      mobile: item?.mobile,
      wallet_limit: item?.wallet_limit
    }
  })
  const notification = useToastContext()
  const [editStaffLoading, setEditStaffLoading] = useState(false)

  const handleSubmitForm = async data => {
    try {
      const sendData = {
        first_name: data?.first_name,
        last_name: data?.last_name,
        email: data?.email,
        country_code: data?.country_code,
        mobile: data?.mobile,
        wallet_limit: data?.wallet_limit
      }
      const res = await apiPut(apiPath.editStaffs + '/' + item._id, sendData)
      if (res.data.success === true) {
        setEditShowModal(false)
        notification.success(res.data.message)
      }
    } catch (err) {
      console.log('err:', err)
    } finally {
      setEditStaffLoading(false)
      getAllStaffs()
    }
  }

  const preventMaxValueName = e => {
    e.target.value = e.target.value.trimStart()
    e.target.value = e.target.value.replace(/  +/g, ' ')
    if (e.target.value.length > 15) {
      e.target.value = e.target.value.slice(0, 15)
    }
  }
  const preventMaxEmail = e => {
    e.target.value = e.target.value.trimStart()
    e.target.value = e.target.value.replace(/  +/g, ' ')
  }

  const handleAmount = e => {
    var value = e.target.value
    const pattern = /^\d{0,7}(\.\d{0,2})?$/
    if (e.target.value === '') {
      e.target.value = e.target.value.slice(e.target.value?.length - 1, -1)
    }
    const isValid = pattern.test(value)
    if (!isValid) {
      value = value.slice(0, -1)
    }
    setValue('wallet_limit', value)
  }
  var pressedKeys = []
  const codeValue = helpers?.ternaryCondition(
    watch('email'),
    watch('email'),
    ''
  )
  return (
    <>
      <div
        id='add-agent'
        className='fixed  pt-16 z-40 h-screen px-6 pb-4 overflow-y-auto bg-white sm:w-96 w-80 right-0 top-0 '
        aria-labelledby='drawer-label'
      >
        <div>
          <button
            onClick={() => setEditShowModal(false)}
            type='button'
            title={t('O_CLOSE')}
            data-drawer-hide='drawer-example'
            aria-controls='drawer-example'
            className='text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 absolute top-2.5 right-2.5 inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white'
          >
            <img src='./images/close-circle.png' alt='close' />

            <span className='sr-only'>{t('CLOSE_MENU')}</span>
          </button>
        </div>
        <h3 className='font-medium text-[18px] mb-4 '>
          {t('STAFF_EDIT_AGENT')}
        </h3>
        <form>
          <div className='relative my-5'>
            <OInputField
              type='text'
              name='first_name'
              inputLabel={
                <>
                  {t('O_FIRST_NAME')}
                  <span className='text-red-500'>*</span>
                </>
              }
              onInput={e => preventMaxValueName(e)}
              register={register('first_name', {
                required: t('PLEASE_ENTER_FIRST_NAME'),
                minLength: {
                  value: 3,
                  message: t('MINIMUM_LENGTH_MUST_BE_3')
                },
                maxLength: {
                  value: 15,
                  message: t('MAXIMUM_LENGTH_MUST_BE_15')
                }
              })}
              errors={errors}
            />
          </div>
          <div className='relative my-5'>
            <OInputField
              type='text'
              name='last_name'
              inputLabel={
                <>
                  {t('O_LAST_NAME')}
                  <span className='text-red-500'>*</span>
                </>
              }
              onInput={e => preventMaxValueName(e)}
              register={register('last_name', {
                required: t('PLEASE_ENTER_LAST_NAME'),
                minLength: {
                  value: 3,
                  message: t('MINIMUM_LENGTH_MUST_BE_3')
                },
                maxLength: {
                  value: 15,
                  message: t('MAXIMUM_LENGTH_MUST_BE_15')
                }
              })}
              errors={errors}
            />
          </div>

          <div className='flex my-5 gap-4'>
            <div class='relative w-full col-span-1'>
              <OInputField
                greyClass
                name='country_code'
                inputLabel={<>{t('O_COUNTRY_CODE')}</>}
                errors={errors}
                type='select'
                register={register('country_code', {})}
                disabled
                selectOptions={[
                  <option value='355' key='355'>
                    +355
                  </option>
                ]}
              />
            </div>

            <div className='relative w-full'>
              <OInputField
                name='mobile'
                inputLabel={
                  <>
                    {t('O_MOBILE_NUMBER')}
                    <span className='text-red-500'>*</span>
                  </>
                }
                errors={errors}
                type='number'
                onKeyDown={e => {
                  if (['-', '+', 'e', '.'].includes(e.key)) {
                    e.preventDefault()
                  }
                }}
                onInput={e => preventMax(e, 9)}
                register={register('mobile', {
                  required: t('PLEASE_ENTER_MOBILE_NUMBER'),
                  minLength: {
                    value: 9,
                    message: t('MINIMUM_LENGTH_SHOULD_BE_9_DIGITS')
                  },
                  maxLength: {
                    value: 9,
                    message: t('MAXIMUM_LENGTH_SHOULD_BE_9_DIGITS')
                  },
                  pattern: {
                    value: validationRules.numbers,
                    message: t('INVALID_MOBILE_NUMBER')
                  },
                  min: {
                    value: 0,
                    message: t('VALUE_CAN_NOT_BE_LESS_THAN_0')
                  }
                })}
              />
            </div>
          </div>

          <div className='relative  my-5'>
            <OInputField
              name='email'
              inputLabel={
                <>
                  {t('O_CUSTOMER_EMAIL_ID')}
                  <span className='text-red-500'>*</span>
                </>
              }
              errors={errors}
              type='email'
              onInput={e => preventMaxEmail(e)}
              value={codeValue.toLowerCase()}
              register={register('email', {
                required: t('PLEASE_ENTER_AGENT_EMAIL_ID'),
                pattern: {
                  value: validationRules.email,
                  message: t('PLEASE_ENTER_VALID_AGENT_EMAIL_ID')
                }
              })}
            />
          </div>
          <div className='relative  my-5'>
            <OInputField
              name='wallet_limit'
              inputLabel={
                <>
                  {t('O_WALLET LIMITATION_AMOUNT')}
                  <span className='text-red-500'>*</span>
                </>
              }
              errors={errors}
              type='number'
              step='any'
              register={register('wallet_limit', {
                required: t('PLEASE_ENTER_WALLET_LIMITATION_AMOUNT'),
                onChange: e => handleAmount(e),
                validate: value => {
                  return value !== '0'
                    ? true
                    : t('VALUE_CAN_NOT_BE_LESS_THAN_0.01')
                }
              })}
              onKeyDown={e => {
                pressedKeys.push(e.key)
                var lastKey = pressedKeys[pressedKeys.length - 2]
                if (lastKey === '.') {
                  if (['-', '.', '+', 'e'].includes(e.key)) {
                    e.preventDefault()
                  }
                } else if (['-', '+', 'e'].includes(e.key)) {
                  e.preventDefault()
                }
              }}
            />
          </div>

          <button
            class='bg-LightBlue hover:bg-DarkBlue cursor-pointer   text-white  font-medium  w-full active:bg-slate-100 text-sm px-8 py-4 rounded-lg shadow hover:shadow-lg outline-none focus:outline-none  ease-linear transition-all duration-150 undefined'
            type='submit'
            onClick={handleSubmit(handleSubmitForm)}
          >
            {helpers?.ternaryCondition(
              editStaffLoading,
              'Loading...',
              <>{t('O_EDIT')}</>
            )}
          </button>
        </form>
      </div>
      <div class='bg-gray-900  bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-30 overlay' />
    </>
  )
}

export default EditStaff
